import { useState, useEffect } from "react";
import { format, parseISO, startOfDay } from "date-fns";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { CalendarIcon } from "lucide-react";
import { cn } from "../../lib/utils";

const DatePicker = ({ onChange, value, minDate, disabled, allowPast = false }) => {
  const [date, setDate] = useState(
    value ? (typeof value === "string" ? parseISO(value) : value) : null
  );

  useEffect(() => {
    setDate(value ? (typeof value === "string" ? parseISO(value) : value) : null);
  }, [value]);

  const today = startOfDay(new Date());

  const handleSelect = (selectedDate) => {
    if (!selectedDate) {
      setDate(null);
      if (onChange) onChange("");
      return;
    }

    const dateString = format(selectedDate, "yyyy-MM-dd");
    setDate(selectedDate);

    if (onChange) {
      onChange(dateString);
    }
  };

  return (
    <div className="w-full focus-visible:ring-0 focus-visible:border-ring">
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            type="button"
            disabled={disabled}
            className={cn(
              "w-full justify-start text-left font-normal h-12",
              !date && "text-muted-foreground",
              disabled && "opacity-50 cursor-not-allowed bg-gray-50"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? format(date, "PPP") : "Select date"}
          </Button>
        </PopoverTrigger>

        <PopoverContent align="start" className="w-auto p-0 bg-white">
          <Calendar
            mode="single"
            selected={date}
            onSelect={handleSelect}
            initialFocus
            disabled={(d) => {
              // const isBeforeToday = d < today;
              const isBeforeToday = allowPast ? false : d < today;
              const isBeforeMinDate = minDate ? d < startOfDay(new Date(minDate)) : false;
              return isBeforeToday || isBeforeMinDate;
            }}
            modifiers={{ today: new Date() }}
            modifiersClassNames={{
              today: "font-semibold bg-accent/50 rounded-full",
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default DatePicker;
